(function() {
    'use strict';

    angular.module('swif.ui')
        .config(route)
        .controller('SwifFrameworkDataController', SwifFrameworkDataController);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/framework/data_post', {
            templateUrl: 'partials/ui/data_post.html',
            controller: 'SwifFrameworkDataController',
            reloadOnSearch: false
        });
        $routeProvider.when('/framework/data_debug_table', {
            templateUrl: 'partials/ui/data_debug.html',
            controller: 'SwifFrameworkDataController',
            reloadOnSearch: false
        });
        $routeProvider.when('/framework/data_debug_explorer', {
            templateUrl: 'partials/ui/data_debug_explorer.html',
            controller: 'SwifFrameworkDataController',
            reloadOnSearch: false
        });
    }

    function SwifFrameworkDataController($scope, $location, swif, $timeout) {
        'ngInject';
        var searchCT = $location.search().contentType;
        $scope.vocab = {
            contentTypes: []
        };
        $scope.contentTypeById = {};
        $scope.results = [];
        $scope.results = [];
        $scope.selectAllFields = true;
        $scope.post = post;
        $scope.selected_fields = [];
        $scope.toggleSelection = toggleSelection;
        _.forEach(swif.settings.app.contentTypes, function(value) {
            $scope.vocab.contentTypes.push({
                id: value.id,
                name: value.title
            });
            $scope.contentTypeById[value.id] = value;
        });
        if (searchCT) {
            $scope.contentType = [searchCT, $scope.contentTypeById[searchCT].title];
        }

        $scope.$watch('contentType', watchContentType);
        $scope.$watch('paramsText', watchParamsText);
        $scope.$watch('selectAllFields', watchSelectAllFields);

        function post() {
            swif.data.post($scope.contentType, $scope.params)
                .then(function(result) {
                    $scope.results.push(result);
                });
        }

        function toggleSelection(key) {
            var index = $scope.selected_fields.indexOf(key);
            if (index !== -1) {
                $scope.selected_fields.splice(index, 1);
            } else {
                $scope.selected_fields.push(key);
            }
        }

        function updateFields() {
            if (!$scope.contentType) {
                return;
            }
            swif.data.getModelFields($scope.contentType[0])
                .then(function(data) {
                    $scope.fields = data;
                    if (!$scope.selectAllFields) {
                        $scope.selected_fields = ['id', 'name'];
                    } else {
                        $scope.selected_fields = _.keys($scope.fields).sort();
                        $scope.selected_fields.unshift('id');
                    }
                });
        }

        function updateCollection() {
            if (!$scope.contentType) {
                return;
            }
            $scope.reload = true;
            var filter = {};
            filter.fields = $scope.selected_fields;
            swif.data.sortOn(filter, 'id', 'DESC');
            swif.collection.createOrUpdate(
                'data_debug',
                $scope.contentType[0],
                filter
            ).then(function(collection) {
                $scope.collection = collection;
                $timeout(function() {
                    $scope.reload = false;
                }, 1000);
            });
        }

        function watchContentType(newV) {
            if (newV) {
                $location.search('contentType', newV[0]);
                updateFields();
                updateCollection();
            }
        }

        function watchParamsText(newV) {
            if (newV) {
                try {
                    $scope.params = JSON.parse(newV);
                    $scope.paramsStatus = true;
                } catch (err) {
                    $scope.paramsStatus = false;
                }
            }
        }

        function watchSelectAllFields(newV) {
            updateFields();
        }
    }
})();
